module.exports = __webpack_public_path__ + "img/show.670823d3.svg";